import { Outlet, useLocation } from "react-router-dom";
import TabLayout from "../_TabLayout";
import { EventsBasePathProvider } from "@/pages/events/_EventsBasePath";

const ACTIVITIES_EVENTS_BASE_PATH = "/activities/events";

export default function ActivitiesEventsLayout() {
  const { pathname } = useLocation();

  const segmentAfterEvents = pathname.split("/").filter(Boolean).slice(2)[0];
  const isEventList = segmentAfterEvents === undefined;

  return (
    <EventsBasePathProvider basePath={ACTIVITIES_EVENTS_BASE_PATH}>
      {isEventList ? (
        <TabLayout>
          <Outlet />
        </TabLayout>
      ) : (
        <Outlet />
      )}
    </EventsBasePathProvider>
  );
}
